<div class="user-settings">
    <h4>User Settings</h4>
    <div class="settings-container">
        <div class="setting" *ngFor="let setting of userSettingsConfigs">
            <h5>{{ setting.label }}</h5>
            <ng-container *ngIf="active && _loaded && setting.isSelect && userSettings[setting.name]">
                <kendo-multiselect
                    [id]="setting.name"
                    [data]="setting.items"
                    [placeholder]="'Choose default ' + setting.name"
                    [valueField]="'name'"
                    [valuePrimitive]="true"
                    [textField]="'label'"
                    [disabled]="disabledSelects[setting.type]"
                    [popupSettings]="{appendTo:'component'}"
                    (valueChange)="onSettingChange($event, setting.type)"
                    [(ngModel)]="userSettings[setting.name].value">
                </kendo-multiselect>
            </ng-container>

            <ng-container *ngIf="active && setting.type === 'extent'">
                <div class="setting-item" *ngFor="let extentItem of setting.items">
                    <p [hidden]="userSettings[setting.name] && userSettings[setting.name] && userSettings[setting.name][extentItem.name]">No {{ extentItem.name }} extent selected</p>
                    <div class="btn-bar">
                        <button class="btn" (click)="clearExtent(setting.name)" [hidden]="!(userSettings[setting.name] && userSettings[setting.name] && userSettings[setting.name][extentItem.name])">Clear {{ extentItem.name }} extent</button>
                        <button class="btn" (click)="setExtent(setting.name, extentItem.name)">Set current extent as {{ extentItem.name }}</button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="active && setting.type === 'check-list'">
                <div class="check-list-item" *ngFor="let checkItem of setting.items">
                    <label class="toggle-switch modifier-class clearfix">
                        <span class="togggle-switch-label left font-size--1">{{ checkItem.label }}</span>
                        <input type="checkbox" [name]="checkItem.name" class="toggle-switch-input" [checked]="userSettings[setting.name] && userSettings[setting.name][checkItem.name]" (change)="checkboxChange(setting.name, checkItem.name)">
                        <span class="toggle-switch-track right"></span>
                    </label>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="btn-bar">
        <button (click)="saveSettings()" class="btn">Save</button>
        <button (click)="cancel()" class="btn">Cancel</button>
    </div>
</div>
